import script from "./BenefitsConfig.vue?vue&type=script&setup=true&lang=js"
export * from "./BenefitsConfig.vue?vue&type=script&setup=true&lang=js"

import "./BenefitsConfig.vue?vue&type=style&index=0&id=69818786&scoped=true&lang=css"

import exportComponent from "/root/workspace/Collection_EVMd/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-69818786"]])

export default __exports__